query PaymentAvailableTags($id: UUID!) {
  paymentAvailableTags(entityId: $id) {
    nodes {
      id
      name
      badgeName
      badgeColor
    }
  }
}
